<template>
  <div class="ask-header">
    <div class="title-wrapper">
      <AiBadge size="medium" class="mr-1" />

      <div v-if="!loading" class="title">
        {{ $t('ask.search.experimental-warning-title') }}
      </div>
      <div v-else class="title">
        {{ $t('ask.search.generating') }}
      </div>
      <div v-if="!loading" class="subtitle">
        {{ $t('ask.search.experimental-warning-subtitle') }}
      </div>
    </div>
    <div
      class="d-flex align-items-center btn-close"
      @click.prevent.stop="$emit('close-ask')"
      v-if="!loading"
    >
      <font-awesome-icon :icon="['fal', 'times']" class="btn-close-icon" />
    </div>
    <div
      v-else
      class="cancel-wrapper"
      @click.prevent.stop="$emit('cancel-ask')"
    >
      {{ $t('ask.search.cancel') }}
      <div class="cancel-as-esc">{{ $t('ask.search.escape') }}</div>
    </div>
  </div>
</template>

<script>
import AiBadge from 'components/AI/AiBadge.vue';
export default {
  name: 'ask-header',
  components: { AiBadge },
  props: {
    loading: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.ask-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.title-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
}
.title {
  color: $purple-5-mayday;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}
.subtitle {
  @extend .title;
  font-weight: 400;
  padding-left: 2px;
}
.btn-close {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  justify-content: center;
  background: $purple-5-mayday;
  cursor: pointer;
}
.btn-close-icon {
  color: white;
  height: 12px;
  width: 12px;
}
.cancel-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: $purple-5-mayday;
  font-size: 14px;
  font-weight: 700;
  &:hover {
    cursor: pointer;
  }
}
.cancel-as-esc {
  padding: 2px 5px 2px 5px;
  font-size: 12px;
  margin-left: 8px;
  border-radius: 4px;
  background-color: rgba($purple-5-mayday, 0.2);
  font-weight: 400;
}
</style>
